import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { supplierservices } from "../../services/supplierServices";

import { StockServices } from "../../services/stockServices";
import { Titlebar, Label } from "../../components/fieldsComp";
import { Submissionbtn } from "../../components/buttons";
import { Formik, Field, Form } from "formik";
import {useSelector} from 'react-redux';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";

import {useStock} from '../../contexts/stockContexts'; 
import { warehouseService } from "../../services/warehouseService";
const WarehouseAdd = () => {
  const [users, setUsers] = useState([]);
  const unitreducer = useSelector((state)=>state.unitreducer);
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [userloaded, setUserloaded] = useState(true);
  const [submitted,setSubmitted] = useState(true);
  const [componentytpe, setComponenttype] = useState("product");
  const [newId, setnewId] = useState('');

  const [supllierlist,setSupllierlist] = useState([]);

  const [units,setUnits] = useState([]);
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [currencies,setCurrencies] = useState([]);
  const navigate = useNavigate();
  

  useEffect(() => {
    getusers();
    getunits();
    getsupplier();
    getcurrency();
    getWarehouseDetails();
    generateWarehouseId();
  }, []);

  const {updateStock,settingsdata,getSettingValue} = useStock();

  const [formData, setFormData] = useState({
    stocktype: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const generateWarehouseId = async () => {
    const response = await warehouseService.getLastWarehouseId();
    if (response.status === 200) {
      const lastId = response.data?.order_id || "WH000";
      const number = parseInt(lastId.replace("WH", ""), 10) + 1;
      const newId = `WH${number.toString().padStart(3, "0")}`;
      setnewId(newId);
    }
  };
 
  useEffect(() => {
    setComponenttype(formData.stocktype);
  }, [formData.stocktype]);

  const getWarehouseDetails = () => {
    StockServices.getWorhouseData().then((response)=>{
      if(response.status == 200){
        setWarehouses(response.data.data);
      }else{
        setWarehouses([]);
      }
    }).catch((error) => {
      console.log("error: " , error);
    })
  }

  
  const handleSave = async (values) => {
    // console.log("Form Data:", values);
    // Add your save logic here
    setLoading(true);
    setSubmitted(false);
    warehouseService
      .addwarehouse(values)
      .then(async (response) => {
        console.log(response);
        if (response.status == 200) {
             setLoading(false);
             setSubmitted(true);
              const randomNum = Math.random();
             updateStock(randomNum);
          //  console.log€0
          await toast.current.show({
            severity: "success",
            summary: "Warehouse added successfully",
            detail: `${response.data.data}`,
          });

          navigate('-1');
        } else {
          setLoading(false);
          setSubmitted(true);
          toast.current.show({
            severity: "error",
            summary: "Stock",
            detail: `${response.data.data}`,
          });
        }
      })
      .catch((error) => {
         setSubmitted(true);
        toast.current.show({
          severity: "error",
          summary: "Stock",
          detail: "Error",
        });
      });
  };

  const handleClose = () => {
    // Reset form or close modal logic
    console.log("Form Closed");
  };

  const getusers = () => {
    setUserloaded(false);
    userservices
      .getusers()
      .then((response) => {
        if (response.status == 200) {
          console.log(response.data.data);
          setUsers(response.data.data);
          setUserloaded(true);
        } else {
          setUsers([]);
          setUserloaded(true);
        }
      })
      .catch((error) => {
        setUsers([]);
        setUserloaded(true);
      });
  };


  const getunits = () =>{
    unitreducer.then((response)=>{
        //  console.log(response);
         setUnits(response);
      }).catch((error)=>{
          
      });
  }

  const getsupplier = () =>{
      supplierservices.getallsupllier().then((response)=>{
        console.warn(response);
          if(response.status ==200){
              setSupllierlist(response.data.data);  
          }else{
              setSupllierlist([]); 
          }
           
        }).catch((error)=>{
              setSupllierlist([]); 
        });
    }


    function displaySupplier2(){
      let supllierdata = [];
      supllierlist.forEach((value,index)=>{
        supllierdata.push(<option value={value.id}>{value.name}</option>); 
      });
      return supllierdata;
   }

  function displayUnits(){
    let unitsarr = [];
    units.forEach((value,index)=>{
      unitsarr.push(<option value={value.short_code}>{value.name}</option>); 
    });

    return unitsarr;
  }

  function getCurrentDateTimeLocal() {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  }


  const getcurrency = () => {
    currencyreducer.then((response)=>{
      
      // console.log("currency reducer");
      // console.log(response);
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 



  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Warehouse / Add Warehouse"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        {/* <Titlebar text={"Add New Warehouse"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                        "warehouse_code":newId,
                        "stock_date": getCurrentDateTimeLocal(),
                        'purchase_currency':getSettingValue('default_currency'),
                        'totalcost_currency':getSettingValue('default_currency')
                    }}
                    onSubmit={async (values) => {
                      console.log("values data");
                      console.log(values);
                      handleSave(values);
                      // handleSave(values);
                      // await new Promise((r) => setTimeout(r, 500));
                      // alert(JSON.stringify(values, null, 2));
                    }}
                  >
                    {({ handleChange, setFieldValue,values }) => (    

                    <Form>
                      <div className="row">
                        <div className="col-md-6 form-group">
                          <Label name="Warehouse Code" />
                          <Field
                            type="text"
                            name="warehouse_code"
                            className="form-control"
                            placeholder="Enter Warehouse Code"
                            onChange={(e) => {
                                setFormData({stocktype:e.target.value});
                                // handleChange(e);
                                // const processedValue = e.target.value.trim();
                                setFieldValue("warehouse_code", e.target.value); 
                            }}
                          >
                          </Field>
                        </div>

                        <div className="col-md-6 form-group">
                          <Label name="Warehouse Name" />
                          <Field
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Enter name"
                            required
                            onChange={(e) => {
                              setFieldValue("name", e.target.value);
                            }}
                          />
                        </div>

                         <div className="col-md-6 form-group">
                          <Label name="Enter Contact Person Name" />
                          <Field
                            type="text"
                            name="contact_person"
                            className="form-control"
                            placeholder="Enter Contact Person"
                            onChange={(e) => {
                                setFieldValue("contact_person", e.target.value); 
                            }}>
                          </Field>
                        </div>

                        <div className="col-md-6 form-group">
                            <Label name="Email" />
                            <Field
                            type="text"
                            name="email"
                            className="form-control"
                            placeholder="Enter  Email"
                            required
                            onChange={(e) => {
                              setFieldValue("email", e.target.value);
                            }}
                            />
                        </div>

                         <div className="col-md-6 form-group">
                          <Label name="Phone Number" />
                          <Field
                            type="number"
                            name="phone"
                            className="form-control"
                            placeholder="Enter phone number"
                            required
                             onChange={(e) => {
                                  setFieldValue("phone", e.target.value); 
                               
                              }}
                          />
                        </div>


                        <div className="col-md-6 form-group">
                            <Label name="Address" />
                       
                            <Field type="text"
                                name="address"
                                className="form-control"
                                placeholder="Enter Address"
                                required
                              onChange={(e) => {
                                setFieldValue("address", e.target.value);
                              }}
                            >
                                
                             </Field>
                        </div>

                        {/* Supplier ID */}
                        <div className="col-md-6 form-group">
                            <Label name="City" />
                            <Field
                            type="text"
                            name="city"
                            className="form-control"
                            placeholder="Enter City"
                            required
                            onChange={(e) => {
                              setFieldValue("city", e.target.value)
                            }}
                            >    
                            </Field>
                        </div>

                    

                        {/* Total Cost */}
                        <div className="col-md-6 form-group">
                            <Label name="Country" />
                             <div className="flex-box">
                           
                              <Field
                                type="text"
                                name="country"
                                className="form-control"
                                placeholder="Enter Country"
                                
                                />   
                            </div>                 
                        </div>

                        {/* Expiry Date */}
                        <div className="col-md-6 form-group">
                            <Label name="Enter Capacity" />
                            <Field
                            type="number"
                            name="capacity"
                            className="form-control"
                            placeholder="Enter Capacity"
                            onChange={(e)=> {
                              setFieldValue('capacity', e.target.value);
                            }}
                            />
                        </div>

                        <div className="col-md-6 form-group">
                            <Label name="Enter State" />
                            <Field
                            type="text"
                            name="state"
                            className="form-control"
                            placeholder="Enter State"
                            onChange={(e)=> {
                              setFieldValue('state', e.target.value);
                            }}
                            />
                        </div>

                        {/* Warehouse Location */}
                        <div className="col-md-6 form-group">
                            <Label name="Postal Code" />
                         
                            <Field type="text" name="postal_code" className="form-control" onChange={(e) => {
                               setFieldValue('postal_code',e.target.value);
                            }} >
                          
                            </Field>   
                        </div>

                       
                      </div>

                      <br></br>
                      {/* <br></br> */}
                      <div className="row">
                        <div className="col-md-6">
                        
                          <Submissionbtn issaved={submitted}/>
                        </div>

                        <div className="col-md-6">
                          <button
                            type="button"
                            className="btn color-white w-100 rounded custom-btn-color-secondary"
                            onClick={handleClose}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </Form>)}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default WarehouseAdd;
